import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

export const connectMyMarkets = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      openBets: state.openBets,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
